import { useMemo } from "react";

import { devWarn } from "@/util/dev.mjs";

// This is a great utility for finding out if your path state for data fetching contains an error
// Do not use this with components that rely on the Error instance
export function filterErrState<T>(state: T | Error | undefined): T | undefined {
  if (!state) return;
  if (state instanceof Error) {
    devWarn("Eval filter encountered an error instance within state");
    return;
  }
  return state;
}

/**
 * Deprecated function for filtering out error state.
 * @deprecated
 */
export function useEvalState<T>(state: T | Error | undefined): T | undefined {
  return useMemo(() => filterErrState(state), [state]);
}
